export enum ETipoTransaccion {
  EFECTIVO = 'EFECTIVO',
  TARJETA = 'TARJETA',
  TRANSFERENCIA = 'TRANSFERENCIA',
  CHEQUE = 'CHEQUE',
  CREDITO = 'CREDITO',
  DIGITAL = 'DIGITAL',
  OTRO = 'OTRO',
}
